import { render, staticRenderFns } from "./zw2.vue?vue&type=template&id=0331d4a0&scoped=true&"
import script from "./zw2.vue?vue&type=script&lang=js&"
export * from "./zw2.vue?vue&type=script&lang=js&"
import style0 from "./zw2.vue?vue&type=style&index=0&id=0331d4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331d4a0",
  null
  
)

export default component.exports